module.exports = __webpack_public_path__ + "media/application/images/wjc@2x-112ff2a4ff98df92e1cffc6ca5465e59b777dacc9eaead2b1f47c6af335cc2c5.png";